import React, { useRef, useEffect, useState } from 'react'
import { useDrag } from 'react-use-gesture'
import { directstyled, useDirectStyle } from 'direct-styled'

const formatTime = seconds => {
  return [Math.floor(seconds / 60), Math.floor(seconds % 60)]
    .map(x => x.toString())
    .map(x => (x.length === 1 ? `0${x}` : x))
    .join(':')
}

const minMax = (min, max, value) => {
  if (value > max) {
    return max
  }
  if (value < min) {
    return min
  }
  return value
}

const getNewTimeProps = (barRect, clientX, duration) => {
  const seconds = minMax(
    0,
    duration,
    Math.floor(((clientX - barRect.left) / barRect.width) * duration),
  )

  const progress = (seconds / duration) * 100

  return { seconds, progress }
}

const TimeBar = ({
  style,
  className,
  duration,
  progress,
  currentTime,
  isSeeking,
  setTime,
}) => {
  const barRef = useRef(null)

  const [barStyle, setBarStyle] = useDirectStyle()
  const [circleStyle, setCircleStyle] = useDirectStyle()
  const [ignoreTimeUpdates, setIgnoreTimeUpdates] = useState(false)

  const setStyles = progress => {
    setCircleStyle({
      left: `${progress}%`,
    })

    setBarStyle({
      background: `linear-gradient(to right, #FE794E 0%, #FE794E ${progress}%, #F9BAA6 ${progress}%, #F9BAA6 100%)`,
    })
  }

  const bind = useDrag(
    ({ xy, first, last, event }) => {
      event.preventDefault()

      if (first) {
        setIgnoreTimeUpdates(true)
      }

      const { seconds, progress } = getNewTimeProps(
        barRef.current.getBoundingClientRect(),
        xy[0],
        duration,
      )

      if (last) {
        setTime(seconds)
        setIgnoreTimeUpdates(false)
        return
      }

      setStyles(progress)
    },
    { event: { passive: false, capture: true } },
  )

  useEffect(() => {
    if (ignoreTimeUpdates) {
      return
    }

    setStyles(progress)
  }, [progress])

  return (
    <div
      className={`timebar ${className || ''}`}
      style={{ ...style }}
    >
      <directstyled.div ref={barRef} className='timebar-bar' style={barStyle}>
        <directstyled.div
          {...bind()}
          className='timebar-circle'
          style={circleStyle}
        />
      </directstyled.div>
      <div><span className='startTime'>{formatTime(currentTime)} / </span><span className='fullTime'>{formatTime(duration)}</span></div>
    </div>
  )
}

export default TimeBar
